// MotionProvider.js — Carregador das features do `motion` para o site inteiro.
//
// Por que LazyMotion + `m` em vez de `motion` direto:
// o componente `motion.div` arrasta todas as features da biblioteca para o
// bundle (~34 kB gzip a mais). Com `LazyMotion features={domAnimation}` +
// os componentes `m.*`, entra só o subconjunto de animação DOM que o site
// usa de verdade — layout animations e drag ficam de fora porque não usamos.
//
// Regra do projeto: TODO componente animado usa `m.*` (nunca `motion.*`),
// caso contrário a otimização acima é perdida silenciosamente.
import React from "react";
import { LazyMotion, domAnimation } from "motion/react";

const MotionProvider = ({ children }) => (
  <LazyMotion features={domAnimation} strict>
    {children}
  </LazyMotion>
);

export default MotionProvider;
